import APICall from '../utils/APICall';

export default class  WithdrawalServices {

    static listCashPickUps = async (page, pageLimit, search, from, to,cashPickupStatus,cashpickUpTypes) => {
        return await APICall(`/api/Cashpickup/admin/list-cashpickups?page=${page}&pageLimit=${pageLimit}&search=${search}&from=${from}&to=${to}&cashPickupStatus=${cashPickupStatus}&cashpickUpTypes=${cashpickUpTypes}`, "GET")
    };
    static exportPickups = async (search, from, to,cashPickupStatus,cashpickUpTypes) => {
        return await APICall(`/api/Cashpickup/admin/export-cashpickups?search=${search}&from=${from}&to=${to}&cashPickupStatus=${cashPickupStatus}&cashpickUpTypes=${cashpickUpTypes}`, "GET");
    }
    static viewCashPickUp = async (authorizationCode) =>{
        return await APICall(`/api/Cashpickup/admin/view-cashpickups?AuthorizationCode=${authorizationCode}`, "GET");
    }
    static approvePickUp = async (authorizationCode, comment, status) => {
        return await APICall('/api/Cashpickup/admin/cashpickups-primary-action', "POST", {
            authorizationCode : authorizationCode,
            comment: comment,
            status:status
        });
    }
    static actionSecPickup = async (authorizationCode, comment, status) =>{
        return await APICall("/api/Cashpickup/admin/cashpickups-secondary-action", "POST", {
            authorizationCode : authorizationCode,
            comment: comment,
            status:status 
        });
    } 
    static summary = async () => {
        return await APICall(`/api/Cashpickup/admin/cashpickup-summary`, "GET")
    }
  
}